import AboutOutput from "../components/outputs/AboutOutput";
import StackOutput from "../components/outputs/StackOutput";
import ExperienceOutput from "../components/outputs/ExperienceOutput";
import ProjectsOutput from "../components/outputs/ProjectsOutput";
import OngoingOutput from "../components/outputs/OngoingOutput";
import ContactOutput from "../components/outputs/ContactOutput";
import HelpOutput from "../components/outputs/HelpOutput";
import LsOutput from "../components/outputs/LsOutput";
import { ROOT, lsEntries, resolveCd, resolveCat, pwdPath } from "./FileSystem";
import { PROFILE } from "../data/portfolio";

const ErrorLine = ({ children }) => <span className="text-neutral-500">{children}</span>;

/**
 * Runs one command line against current shell state.
 * Returns { output, newCwd, clearScreen } — any of output/newCwd may be omitted.
 */
export function runCommand(raw, cwd) {
  const [cmd, ...args] = raw.trim().split(/\s+/);
  const key = (cmd || "").toLowerCase();
  const arg = args.join(" ");

  switch (key) {
    case "help":
      return { output: <HelpOutput /> };

    case "about":
    case "whoami":
      return { output: <AboutOutput /> };

    case "stack":
    case "skills":
      return { output: <StackOutput /> };

    case "experience":
      return { output: <ExperienceOutput /> };

    case "projects":
      return { output: <ProjectsOutput /> };

    case "ongoing":
      return { output: <OngoingOutput /> };

    case "contact":
      return { output: <ContactOutput /> };

    case "pwd":
      return { output: <span className="text-neutral-300">{pwdPath(cwd, PROFILE.user)}</span> };

    case "ls":
      return { output: <LsOutput entries={lsEntries(cwd)} /> };

    case "cd": {
      const res = resolveCd(cwd, arg);
      if (!res.ok) return { output: <ErrorLine>{res.error}</ErrorLine> };
      return { newCwd: res.cwd };
    }

    case "cat": {
      const res = resolveCat(cwd, arg);
      if (!res.ok) return { output: <ErrorLine>{res.error}</ErrorLine> };
      return { output: res.node };
    }

    case "clear":
      return { clearScreen: true };

    case "sudo":
      return { output: <span className="text-neutral-400">nice try. permission denied.</span> };

    case "date":
      return { output: <span className="text-neutral-400">{new Date().toString()}</span> };

    case "":
      return {};

    default:
      return {
        output: (
          <span className="text-neutral-500">
            command not found: <span className="text-neutral-300">{cmd}</span>. type{" "}
            <span className="text-emerald-400">help</span> for a list of commands.
          </span>
        ),
      };
  }
}

export { ROOT };